var React = require('react');

function BellSlash (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M370 416H128.1c-19.12 0-32-15.6-32.1-32a31.24 31.24 0 0 1 8.61-21.71c16.21-17.42 44-42.79 52.62-110.75zm173.64-27.59A32.49 32.49 0 0 0 544 384a31.23 31.23 0 0 0-8.61-21.71c-19.32-20.76-55.47-52-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32a32 32 0 1 0-64 0v20.84c-40.31 8.37-74.89 30.89-97.9 62.33zM320 512a64 64 0 0 0 64-64H256a64 64 0 0 0 64 64z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M633.82 458.09L45.47 3.38A16 16 0 0 0 23 6.17L3.37 31.46a16 16 0 0 0 2.81 22.45l588.34 454.71a16 16 0 0 0 22.48-2.79l19.64-25.27a16 16 0 0 0-2.82-22.47z","className":"fa-primary","key":2})]);
}

BellSlash.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = BellSlash;

BellSlash.default = BellSlash;
